import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'src/app/auth/auth.service';
import { Lesson } from 'src/app/core/models/lesson';
import { ExerciseState } from 'src/app/keylesson/keylesson-player/keylesson-player.component';

export interface KeylessonDialogData {
  lesson: Lesson,
  state: ExerciseState
}

@Component({
  selector: 'app-keylesson-results-dialog',
  templateUrl: './keylesson-results-dialog.component.html',
  styleUrls: ['./keylesson-results-dialog.component.scss']
})
export class KeylessonResultsDialogComponent implements OnInit {

  video: string;
  shouldPass: boolean;

  constructor(
    private authService: AuthService,
    public dialogRef: MatDialogRef<KeylessonResultsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: KeylessonDialogData) { }

  ngOnInit(){
    // video decision
    this.setupVideo();
  }

  setupVideo() {    
    const {language_in_use} = this.authService.user$.value;
    if(this.accuracy < 95) {
      this.video = `https://platform.keyboardpro.com/lang/${language_in_use}/kbp/MP4/KF2.mp4`;
      this.shouldPass = false;      
      console.log('Rule #1, accuracy: ', this.accuracy);
      return;
    }

    if(this.wpm < 20) {
      this.video = `https://platform.keyboardpro.com/lang/${language_in_use}/kbp/MP4/KF1.mp4`;
      this.shouldPass = true;      
      console.log('Rule #2, wpm: ', this.wpm);
      return;
    }

    this.video = `https://platform.keyboardpro.com/lang/${language_in_use}/kbp/MP4/KP2.mp4`;
    this.shouldPass = true;
    console.log('Rule #3');
  }

  get timeElapsed(): string {
    const timeFormatted = new Date(this.data.state.timeSpent * 1000).toISOString().substr(11, 8)

    return timeFormatted;
  }

  get wpm(): number {    
    const errors = this.data.state.totalErrors + this.data.state.errors;
    const strokes = this.data.state.totalStrokes + this.data.state.strokes;

    const timeMinutes = (this.data.state.timeSpent / 60);

    const grossWPM = ( strokes / 5 ) / timeMinutes;
    let netWPM = grossWPM - (errors / timeMinutes)
    
    netWPM = netWPM > 0 
      ? netWPM
      : 0;

    return isNaN(netWPM) 
      ? 0
      : +netWPM.toFixed(2);
  }  

  get accuracy(): number {
    const errors = this.data.state.totalErrors + this.data.state.errors;
    const strokes = this.data.state.totalStrokes + this.data.state.strokes;
    
    const accuracy = ( (strokes - errors) / strokes ) * 100;
    
    return isNaN(accuracy)
      ? 0
      : +accuracy.toFixed(2);
  }

}
